<template>
  <div id="afterSalePage">
    售后管理
  </div>
</template>
<script>
export default {
  name: 'afterSalePage',
  data() {
    return {

    };
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/afterSaleManage/afterSaleManage.vue